import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Tooltip,
} from "@mui/material";
import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GET_EMPLOYEE_DROPDOWN_LIST,
  // GET_REPORT_TASK,
  GET_DETAIL_TASK,
} from "../../../components/utils";
import { getRequest } from "../../../components/axiosClient";
import { errorNotification } from "../../../components/toast-notification/common-toast";
import CustomDataGridTable from "../../../components/common/DataGridTable";
import Select from "react-select";
import LoadingSpinner from "../../../components/loader/LoadingSpinner";
import html2canvas from "html2canvas";

const Repotemployeedetailstask = () => {
  const [getAlltask, setgetAlltask] = useState(null);
  // const [getDetailTask, setDetailTask] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const tableRef = useRef();

  const CopyTableColumn = ({ tableRef }) => ({
    field: "copy_table",
    headerName: "Take Screenshot",
    width: 150,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: () => {
      const handleScreenshotCopy = async () => {
        if (!tableRef.current) {
          alert("Table reference not found!");
          return;
        }

        try {
          const canvas = await html2canvas(tableRef.current, {
            scale: 2, // higher resolution
            useCORS: true, // support for external fonts/images
            backgroundColor: "#fff", // white background
            ignoreElements: (el) => el.classList?.contains("no-screenshot"), // Optional: skip unwanted elements
          });

          canvas.toBlob(async (blob) => {
            if (blob) {
              await navigator.clipboard.write([
                new ClipboardItem({
                  "image/png": blob,
                }),
              ]);
              alert("📸 Table screenshot copied to clipboard!");
            }
          });
        } catch (error) {
          console.error("Screenshot error:", error);
          alert("Failed to copy screenshot.");
        }
      };

      return (
        <Button onClick={handleScreenshotCopy} variant="outlined" size="small">
          Copy Table
        </Button>
      );
    },
  });

  const getReportAllEmployeetask = async () => {
    try {
      setLoading(true);

      // Build URL conditionally
      // const apiUrl = selectedUser
      //   ? `${GET_DETAIL_TASK}?user_id=${selectedUser.value}`
      //   : GET_DETAIL_TASK;
      let apiUrl = `${GET_DETAIL_TASK}${
        selectedUser?.value ? "?user_id=" + selectedUser?.value : ""
      }`;

      const res = await getRequest(apiUrl, null, navigate);
      console.log("API URL:", apiUrl);
      console.log("Response:", res);

      if (res.data && res.data.data) {
        setgetAlltask(res.data.data);
      } else {
        setgetAlltask([]);
      }

      setLoading(false);
    } catch (error) {
      errorNotification(error);
      setLoading(false);
    }
  };

  const getUsersList = async () => {
    try {
      const url = `${GET_EMPLOYEE_DROPDOWN_LIST}`;
      const res = await getRequest(url, null, navigate);
      if (res.data && Array.isArray(res.data.data)) {
        const options = res.data.data.map((project) => ({
          label: `${project?.first_name} ${project?.last_name}`,
          value: project?.id,
        }));
        setUserList([...options]);
      } else {
        setUserList([]);
      }
    } catch (error) {
      errorNotification(error.message);
    }
  };

  useEffect(() => {
    getUsersList();
  }, []);

  useEffect(() => {
    if (selectedUser !== null) {
      getReportAllEmployeetask();
    } else {
      setgetAlltask(null); // Clear previous data if needed
    }
  }, [selectedUser]);

  // console.log("getDetailTask", getDetailTask);
  console.log("getAlltask", getAlltask);

  const columns = [
    {
      field: "first_name",
      headerName: "First Name",
      width: 150,
    },
    {
      field: "last_name",
      headerName: "Last Name",
      width: 150,
    },
    {
      field: "role",
      headerName: "Role",
      width: 150,
    },
    {
      field: "projects",
      headerName: "Project Task Status",
      width: 800,
      renderCell: (params) => {
        if (!params.value || params.value.length === 0) {
          return "No Projects";
        }
        return (
          <TableContainer
            component={Paper}
            sx={{ boxShadow: "none", width: "100%", p: "8px 0px" }}
          >
            <div ref={tableRef} className="screenshot-wrapper">
              <Table size="small" sx={{ border: "1.2px solid #e0e0e0" }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ padding: 0, textAlign: "left" }}>
                      <strong>Project Name</strong>
                    </TableCell>
                    <TableCell sx={{ padding: 0, textAlign: "left" }}>
                      <strong>Task</strong>
                    </TableCell>
                    <TableCell sx={{ padding: 0, textAlign: "left" }}>
                      <strong>Sub Tasks</strong>
                    </TableCell>
                    <TableCell sx={{ padding: 0, textAlign: "left" }}>
                      <strong>Task Status</strong>
                    </TableCell>
                    <TableCell sx={{ padding: 0, textAlign: "left" }}>
                      <strong>Due Date</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {params.value.map((project) =>
                    (project.tasks || []).map((task, index) => (
                      <TableRow key={`${project.id}-${index}`}>
                        <TableCell sx={{ padding: 0, textAlign: "left" }}>
                          {project.name}
                        </TableCell>
                        <TableCell sx={{ padding: 0, textAlign: "left" }}>
                          <Tooltip title={task?.description || ""}>
                          {task.title}
                          </Tooltip>
                        </TableCell>
                        <TableCell sx={{ padding: 0 }}>
                          {task.subTasks.length > 0
                            ? task.subTasks.map((sub, i) => (
                                <div key={i}>• {sub}</div>
                              ))
                            : "-"}
                        </TableCell>

                        <TableCell sx={{ padding: 0, textAlign: "left" }}>
                          {task.status}
                        </TableCell>
                        <TableCell sx={{ padding: 0, textAlign: "left" }}>
                          {task.due_date}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </div>
          </TableContainer>
        );
      },
    },
    CopyTableColumn({ tableRef }),
    // {
    //   field: "copy_table",
    //   headerName: "Copy Table",
    //   width: 150,
    //   sortable: false,
    //   filterable: false,
    //   disableColumnMenu: true,
    //   renderCell: () => {
    //     const handleCopyTable = () => {
    //       const header = [
    //         "Project Name",
    //         "Task",
    //         "Sub Tasks",
    //         "Task Status",
    //         "Due Date",
    //       ].join(", ");

    //       const allRows = rows.flatMap((row) => {
    //         if (!row.projects || row.projects.length === 0) {
    //           return [["-", "-", "-", "-", "-"].join(", ")];
    //         }

    //         return row.projects.flatMap((project) =>
    //           project.tasks.map((task) =>
    //             [
    //               project.name,
    //               task.title,
    //               task.subTasks.join(", "),
    //               task.status,
    //               task.due_date,
    //             ].join(", ")
    //           )
    //         );
    //       });

    //       const output = [header, ...allRows].join("\n");

    //       navigator.clipboard.writeText(output).then(() => {
    //         alert("Data Copied To Clipboard");
    //       });
    //     };

    //     return (
    //       <Button onClick={handleCopyTable} variant="outlined" size="small">
    //         Copy Table
    //       </Button>
    //     );
    //   },
    // },
  ];

  console.log("getAlltask", getAlltask);

  const rows = (
    Array.isArray(getAlltask) ? getAlltask : getAlltask ? [getAlltask] : []
  ).map((data) => ({
    id: data?.id,
    first_name: data?.first_name || "-",
    last_name: data?.last_name || "-",
    role: data?.role?.name || "-",
    projects: (data?.project_members || []).map((member) => {
      const project = member?.project || {};
      const tasks = project?.tasks || [];

      const mappedTasks = tasks.map((task) => ({
        title: task?.title || "Untitled",
        description: task?.description || "-",
        status: task?.task_status?.title || "Unknown",
        due_date: task?.due_date || "-",
        subTasks: (task?.sub_tasks || []).map(
          (subTask) => subTask?.title || "Untitled Subtask"
        ),
      }));

      return {
        id: project.id || 0,
        name: project.name || "-",
        tasks: mappedTasks,
      };
    }),
  }));

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      height={"100%"}
      width={"100%"}
    >
      <Select
        placeholder="Select user"
        className="rounded-lg text-capitalize max-w-60 m-2"
        type="text"
        options={userList}
        name="assignee to"
        isClearable={true}
        value={userList.find((option) => option.value === selectedUser?.value)}
        onChange={(selectedOption) => setSelectedUser(selectedOption)}
      />
      <Box flex={1} overflow={"auto"}>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <CustomDataGridTable
            columns={columns}
            rows={rows}
            hideFooter={true}
            unstable_strictMode={false}
            getRowHeight={() => "auto"}
            sx={{
              "& .MuiDataGrid-cell": {
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
              },
              "& .MuiDataGrid-cell--rowSpan": {
                display: "flex",
                alignItems: "center", // Ensure row-spanned cells align in the middle
                justifyContent: "center",
                //   height: "20%", // Stretch across the entire row-span height
              },
            }}
            slots={{
              noRowsOverlay: () => (
                <Box
                  height="100%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  fontSize={16}
                  fontWeight="500"
                  color="#888"
                >
                  Please select a user.
                </Box>
              ),
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default Repotemployeedetailstask;
